module.exports = __webpack_public_path__ + "static/media/gem.67157bc6.svg";